"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var PriceTagSC = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nuser-select: none;\n\ndisplay: inline-block;\nbox-sizing: border-box;\n\nheight: 2rem;\nmargin-left: 0.75rem;\n\nfont-size: ", ";\nline-height: ", ";\nfont-weight: ", ";\ntext-align: right;\n\nwill-change: color;\ntransition: color 0.3s;\n\n&::before {\n  content: \"", "\";\n}\n"], ["\nuser-select: none;\n\ndisplay: inline-block;\nbox-sizing: border-box;\n\nheight: 2rem;\nmargin-left: 0.75rem;\n\nfont-size: ", ";\nline-height: ", ";\nfont-weight: ", ";\ntext-align: right;\n\nwill-change: color;\ntransition: color 0.3s;\n\n&::before {\n  content: \"", "\";\n}\n"])), function (props) { return props.theme.SizeFontButtonContainedPrice; }, function (props) { return props.theme.SizeLineHeightButtonContainedPrice; }, function (props) { return props.theme.ContentFontWeightButtonContainedPrice; }, function (props) { return props.currency; });
var PriceTag = function (props) {
    var currency = props.currency, price = props.price;
    return react_1.default.createElement(PriceTagSC, { currency: currency }, price.toFixed(2));
};
PriceTag.propTypes = {
    currency: prop_types_1.default.string.isRequired,
    price: prop_types_1.default.number.isRequired
};
exports.default = PriceTag;
var templateObject_1;
//# sourceMappingURL=PriceTag.js.map